enum ModalTypes {
    Share,
    SignIn,
    SignUp,
    LogInNew,
    SignUpNew,
    SignUpNewDirectToSignupSuccess,
    SignUpToSubscribe,
    SignUpRemoveWatermark,
    SignUpToFollowCollection,
    SignUpToFollowProfile,
    ForgotPassword,
    PremiumContent,
    ShowMoreDescription,
    GetTheApp,
    GetTheAppForFeature,
    DownloadTheApp,
    CancelSubscription,
    SubscriptionError,
    SignUpNewLandingPageV2,
}

export default ModalTypes;
